export default __webpack_public_path__ + "static/bg-counterfactual-2-663c2f89cb03c169cdea21051b6d4c4a.png";